import axios from 'axios'

export const DASHBOARD_URL = `${process.env.REACT_APP_API_URL}/dashboard`

export type DashboardStatisticsFilter = {
  timestamp: string;
  timePeriod?: string;
  from?: Date;
  to?: Date;
  chargerType?: string;
  chargerStatus?: string;
  siteId?: number;
  siteIds?: number[];
}

export type DashboardChartMetric = 'activeKwh' | 'completedSessions' | 'revenueShare' | 'totalEnergy' | 'utilisationRate' | 'co2Emissions'

export type DashboardChartDataFilter = DashboardStatisticsFilter & {
  metric?: DashboardChartMetric;
}

export type DashboardChartDataPoint = {
  date: string;
  value: number;
}

export const getStatistics = async (filter: DashboardStatisticsFilter) => {
  const response = await axios.post(`${DASHBOARD_URL}/getstatistics`, filter)
  return response
}

export const getChartData = async (filter: DashboardChartDataFilter) => {
  const response = await axios.post<DashboardChartDataPoint[]>(`${DASHBOARD_URL}/getchartdata`, filter)
  return response
}

export const syncStatistics = async () => {
  // POST to /dashboard/sync endpoint
  return axios.post(`${DASHBOARD_URL}/sync`)
}
